import { StyleSheet } from 'react-native';

import { observer } from 'mobx-react';

import { LinearGradient } from 'expo-linear-gradient';

import { colors } from '@/constants/colors';

const DefaultBackground: React.FC = () => {
  return (
    <LinearGradient
      colors={[colors.brand.primary, colors.white.primary]}
      start={{ x: 0, y: 0 }}
      end={{ x: 0.5, y: 1 }}
      style={[
        StyleSheet.absoluteFill,
        {
          bottom: '-120%',
          right: '-150%',
        },
      ]}
    />
  );
};

export default observer(DefaultBackground);
